import Vue from 'vue'
import Vuex from 'vuex'

import cduState from '@/store/modules/cdu'
import bettingOfferState from '@/store/modules/bettingOffer'
import livebettingState from '@/store/modules/livebetting'
import screenState from '@/store/modules/screen'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    debugLevel: false,
    translationsLoaded: undefined
  },

  getters: {
    getDebugLevel (state) {
      return state.debugLevel
    },
    getTranslationsLoaded (state) {
      return state.translationsLoaded
    }
  },

  mutations: {
    setDebugLevel (state, level) {
      state.debugLevel = level
    },
    setTranslationsLoaded (state, data) {
      state.translationsLoaded = data
    }
  },

  actions: {
  },

  modules: {
    cduState,
    bettingOfferState,
    livebettingState,
    screenState
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js